import React from 'react';
import { Log } from 'ng2-logger';
import { Pagination, PaginationItem, PaginationLink, UncontrolledTooltip } from 'reactstrap';
import { IPaginateProps } from '../../models/components/paginate';
import Translator from '../../core/i18n';
import Tooltip from '../tooltip/main';

const _logger = Log.create('Paginate');
const L = Log.create('Paginate');
const T = Translator.create();

export default class Paginate extends React.Component<IPaginateProps, any> {

    constructor(props?: any) {
        super(props);
    }

    public onChange = (e: React.MouseEvent<HTMLAnchorElement>) => {
        let page: number = 1;
        if (e && e.currentTarget && e.currentTarget.dataset.page) {
            // tslint:disable-next-line
            page = parseInt(e.currentTarget.dataset.page);
        }

        if (this.props.onPageChange) {
            this.props.onPageChange(page);
        }
    }

    public render() {
        const F = this.props.filters;
        const max: number = F ? Math.floor(F.total! / F.take!) + ((F.total! % F.take!) === 0 ? 0 : 1) : 1;
        const page = F ? (F.page || !F.skip ? F.page : (F.take! + F.skip) / 10) : -1;
        const disableNext: boolean = F && page! < max ? false : true;
        const disablePrev: boolean = F && page! > 1 ? false : true;
        return (
            <Pagination className={this.props.class ? this.props.class : ''}>
                  <Tooltip data={T.t('r_first_page')} position='top' >
                <PaginationItem id="t-first" disabled={disablePrev}>
                    <PaginationLink tag="button" first={true} data-page={1} onClick={this.onChange} disabled={disablePrev}/>
                </PaginationItem>
                </Tooltip>

                <Tooltip data={T.t('r_previous_page')} position='top' >
                <PaginationItem id="t-prev" disabled={disablePrev}>
                    <PaginationLink tag="button" previous={true} data-page={page ? page - 1 : -1} onClick={this.onChange} disabled={disablePrev}/>
                </PaginationItem>
                </Tooltip>
                {
                    this.props.filters && F ? 
                    (
                        <Tooltip data={T.t('r_current_and_total_amount')} position='top' >
                        <PaginationItem id="t-current" disabled={true} active={true}>
                            <PaginationLink tag="button" disabled={true}>
                                {((page! - 1) * F.take!) + 1} - {F.total! < page! * F.take! ? F.total : page! * F.take!} / {F.total}
                            </PaginationLink>
                        </PaginationItem>
                        </Tooltip>
                        
                    )
                    : (null)
                }
                 <Tooltip data={T.t('r_next_page')} position='top' >
                <PaginationItem id="t-next" disabled={disableNext}>
                    <PaginationLink tag="button" next={true} data-page={page ? page + 1 : -1} onClick={this.onChange} disabled={disableNext}/>
                </PaginationItem>
                </Tooltip>
                <Tooltip data={T.t('r_last_page')} position='top' >
                <PaginationItem id="t-last" disabled={disableNext}>
                    <PaginationLink tag="button" last={true} data-page={max} onClick={this.onChange} disabled={disableNext}/>
                </PaginationItem>
                </Tooltip>
            </Pagination>
        );
    }
}

